import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUserInfo } from 'model'
import { AppThunk } from '../index'
export interface UserInfoState extends IUserInfo{}
const initialState: UserInfoState = {
  mobile: '',
  // loginTimes: '',
  // headUrl: '',
  // lastLoginDate: '',
  // userId: '',
  // addDate: '',
  // version: '',
  // token: '',
  realName: '',
  // roleName: '',
  // id: '',
  // position: '',
  // email: '',
  // status: '',
  // roleId: ''
}

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfoState(state, action: PayloadAction<UserInfoState>) {
      state.mobile = action.payload.mobile
      state.loginTimes = action.payload.loginTimes
      state.headUrl = action.payload.headUrl
      state.lastLoginDate = action.payload.lastLoginDate
      state.userId = action.payload.userId
      state.addDate = action.payload.addDate
      state.version = action.payload.version
      state.token = action.payload.token
      state.realName = action.payload.realName
      state.roleName = action.payload.roleName
      state.id = action.payload.id
      state.position = action.payload.position
      state.email = action.payload.email
      state.status = action.payload.status
      state.roleId = action.payload.roleId
    }
  }
})
export const getUserInfoAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(false)
  }
}

export default userInfoSlice.reducer

export const { setUserInfoState } = userInfoSlice.actions
